export default __webpack_public_path__ + "static/client8-9eae6483cf2b9fb986343bec6ffea598.svg";